import React from "react";
import s from './ButtonSmall.module.scss'

export const ButtonSmall = ({onClick = () => {}, value="", disabled, red=false }) => {
    return <button onClick={onClick} className={`${red ? s.formButtonRed : s.formButton  }`} disabled={disabled}>{value}</button>
}